// Accomodation data for Accomodation page

const accomodationData = [
  {
    id: 1,
    type: 'PG',
    businessname: 'Sunrise PG for Ladies',
    location: 'Mangalore',
    areaname: 'Kadri',
    description: 'AC/Non-AC, WiFi, food, 2/3 sharing, walkable to bus stop.',
    featured: true,
    price: '₹6,000/month',
    contactno: '98#####111',
    contactperson: 'Anita Sharma',
    imagepath: '/images/accomodationimages/2_mangalore_urva_a1.jpg'
  },
  {
    id: 2,
    type: 'Hostel',
    businessname: 'Greenfield Boys Hostel',
    location: 'Mangalore',
    areaname: 'Bejai',
    description: '24/7 security, mess, study hall, attached bathrooms.',
    featured: true,
    price: '₹5,500/month',
    contactno: '98#####222',
    contactperson: 'Rahul Verma',
    imagepath: '/images/accomodationimages/rental_apartment2bhk.jpg'
  },
  {
    id: 3,
    type: 'Room',
    businessname: 'Single Room Available',
    location: 'Mangalore',
    areaname: 'Kankanady',
    description: 'Furnished, attached bath, for working professionals.',
    featured: true,
    price: '₹4,000/month',
    contactno: '98#####333',
    contactperson: 'Anil Kumar',
    imagepath: '/images/accomodationimages/rental_independent_house2025_mangalore.jpg'
  },
  {
    id: 4,
    type: 'PG',
    businessname: 'Kambala PG for Ladies',
    location: 'Mangalore',
    areaname: 'Kadri',
    description: 'AC/Non-AC, WiFi, food, 2/3 sharing, walkable to bus stop.',
    featured: true,
    price: '₹5,000/month',
    contactno: '98#####101',
    contactperson: 'Anita Sharma',
    imagepath: '/images/accomodationimages/2_mangalore_urva_a1.jpg'
  },
  {
    id: 5,
    type: 'Hostel',
    businessname: 'City Boys Hostel',
    location: 'Mangalore',
    areaname: 'Bejai',
    description: '24/7 security, mess, study hall, attached bathrooms.',
    featured: true,
    price: '₹4,500/month',
    contactno: '98#####232',
    contactperson: 'Rahul Verma',
    imagepath: '/images/accomodationimages/2_mangalore_urva_a1.jpg'
  },
  {
    id: 6,
    type: 'Room',
    businessname: 'Single/Sharing Room Available',
    location: 'Mangalore',
    areaname: 'Padil',
    description: 'Furnished, attached bath, for working professionals.',
    featured: true,
    price: '₹3,000/month',
    contactno: '98#####303',
    contactperson: 'Anil Kumar',
    imagepath: '/images/accomodationimages/rental_apartment2bhk.jpg'
  }
];

export default accomodationData;
